import {Action} from 'redux'
import {NabilAuctionSubscriberModel} from '../Model/Model'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialNabilAuctionSubscriberState: INabilAuctionSubscriberState = {
  loading: false,
  success: false,
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  toggleLoading: false,
  data: {nabilAuctionSubscriber: [], meta: {}},
}

export interface INabilAuctionSubscriberState {
  loading?: boolean
  success?: boolean
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  toggleLoading?: boolean
  data?: {
    nabilAuctionSubscriber?: NabilAuctionSubscriberModel[]
    meta?: {[key: string]: string | number}
  }
  error?: any
}

export const reducer = (
  state: INabilAuctionSubscriberState = initialNabilAuctionSubscriberState,
  action: ActionWithPayload<INabilAuctionSubscriberState>
) => {
  switch (action.type) {
    // GET subscriber
    case actionTypes.GET_NABIL_AUCTION_SUBSCRIBER_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_NABIL_AUCTION_SUBSCRIBER_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_NABIL_AUCTION_SUBSCRIBER_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    // Delete
    case actionTypes.DELETE_NABIL_AUCTION_SUBSCRIBER_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_NABIL_AUCTION_SUBSCRIBER_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_NABIL_AUCTION_SUBSCRIBER_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    // Enable
    case actionTypes.ENABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ENABLE_NABIL_AUCTION_SUBSCRIBER_SUCCESS: {
      return {
        ...state,
        enableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.ENABLE_NABIL_AUCTION_SUBSCRIBER_FINISH: {
      return {
        ...state,
        loading: false,
        enableSuccess: false,
      }
    }

    // Disable
    case actionTypes.DISABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.DISABLE_NABIL_AUCTION_SUBSCRIBER_SUCCESS: {
      return {
        ...state,
        disableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DISABLE_NABIL_AUCTION_SUBSCRIBER_FINISH: {
      return {
        ...state,
        loading: false,
        disableSuccess: false,
      }
    }

    // Single Enable
    case actionTypes.SINGLE_ENABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ENABLE_NABIL_AUCTION_SUBSCRIBER_SUCCESS: {
      const changedData: any = action.payload?.data?.nabilAuctionSubscriber
      let newData = state?.data?.nabilAuctionSubscriber?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })
      return {
        ...state,
        data: {...state?.data, nabilAuctionSubscriber: newData},
        singleEnableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_ENABLE_NABIL_AUCTION_SUBSCRIBER_FINISH: {
      return {
        ...state,
        singleEnableSuccess: false,
        toggleLoading: false,
      }
    }

    // Single Disable
    case actionTypes.SINGLE_DISABLE_NABIL_AUCTION_SUBSCRIBER_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_DISABLE_NABIL_AUCTION_SUBSCRIBER_SUCCESS: {
      const changedData: any = action.payload?.data?.nabilAuctionSubscriber
      let newData = state?.data?.nabilAuctionSubscriber?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })

      return {
        ...state,
        data: {...state?.data, nabilAuctionSubscriber: newData},
        singleDisableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_DISABLE_NABIL_AUCTION_SUBSCRIBER_FINISH: {
      return {
        ...state,
        singleDisableSuccess: false,
        toggleLoading: false,
      }
    }

    default:
      return state
  }
}
